<template>
  <v-row align="center" justify="center">
    <v-col class="text-center px-5" cols="12" md="9">
      <v-col cols="12">
        <v-btn
          icon
          title="Consultar por Nombre o Razón Social"
          aria-label="Consultar por Nombre o Razón Social"
        >
          <v-icon class="iconos" size="60">fas fa-file-invoice</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" class="mt-1">
        <span
          class="font-weight-bold leading--text mb-3"
          :style="
            $vuetify.breakpoint.xs ? 'font-size: 25px' : 'font-size: 32px'
          "
        >Consultar por Nombre o Razón Social</span>
        <br />
        <span
          :class="
            $vuetify.breakpoint.xs
              ? 'font-weight-regular body-1'
              : 'font-weight-regular title'
          "
        >Sujeto Procesal</span>
        <v-col cols="12" md="8" class="mx-auto">
          <!-- <v-row class="mt-4">
              <v-col cols="4">
                <v-checkbox
                    v-model="conFecha"
                    label="Con actuaciones recientes:"
                    class="mt-n1"
                ></v-checkbox>
              </v-col>
              <v-col cols="4">
                <form-input
                    label="Días"
                    placeholder="Introduzca los días"
                    type="number"
                    v-model="dias"
                    hint="No mayor a 30 días"
                    :disabled="!conFecha"
                ></form-input>
                  <v-text-field v-model="dias" type="number" :disabled="!conFecha" outlined background-color="white" label="Introduzca los días" placeholder="10" hint="No mayor a 30 días" dense />
              </v-col>
              <v-col cols="4">
                <form-input
                    label="Fecha"
                    placeholder="Introduzca la fecha"
                    type="date"
                    hint="No mayor a 30 días"
                    v-model="fecha"
                    :min="minFecha"
                    :max="maxFecha"
                    :disabled="!conFecha"
                ></form-input>
               <v-menu ref="menu" v-model="menu" right :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y max-width="280px" min-width="280px">
                  <template v-slot:activator="{ on, attrs }">
                     <v-text-field v-model="fecha" v-bind="attrs" v-on="on" :disabled="!conFecha" outlined background-color="white" label="Introduzca la fecha" placeholder="aa-mm-dd" dense />
                  </template>
                  <v-date-picker v-model="fecha" no-title :min="minFecha" :max="maxFecha" persistent-hint type="date" width="280" @input="menu = false" color="primary">
                  </v-date-picker>
               </v-menu>
                   <v-menu
                     ref="menu"
                     v-model="menu"
                     :close-on-content-click="false"
                     transition="scale-transition"
                     offset-y
                     max-width="290px"
                     min-width="290px"
                  >
                     <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                        v-model="date"
                        label="Date"
                        hint="MM/DD/YYYY format"
                        persistent-hint
                        v-bind="attrs"
                        v-on="on"
                        ></v-text-field>
                     </template>
                     <v-date-picker v-model="date" no-title @input="menu = false"></v-date-picker>
                  </v-menu>
              </v-col>
          </v-row>-->

          <v-row>
            <v-col cols="12">
              <v-card elevation="10" class="px-5 py-1 processFilterBox mb-3">
                <v-radio-group v-model="soloActivos" mandatory>
                  <v-radio
                    color="primary"
                    :value="true"
                    label="Procesos con Actuaciones Recientes (últimos 30 días)"
                  />
                  <v-radio
                    color="primary"
                    :value="false"
                    label="Todos los Procesos (consulta completa, menos rápida)"
                  />
                </v-radio-group>
              </v-card>
            </v-col>
          </v-row>

          <form-select
            label="Tipo de Persona"
            :items="tipoPersonas"
            itemText="name"
            itemValue="cod"
            :required="true"
            v-model="selectTipoPersona"
            :pushError="errorTipoPersona"
            @input="
              () => {
                if (selectTipoPersona != '') errorTipoPersona = false;
              }
            "
          ></form-select>
          <form-input
            label="Nombre(s) Apellido o Razón Social"
            placeholder="Introduzca el dato.. Ejemplo: Juan Carlos Jimenez"
            :required="true"
            :clearable="true"
            v-model="nombre"
            :pushError="errorNombre"
            @input="
              () => {
                if (nombre != '') errorNombre = false;
              }
            "
          ></form-input>
          <generate-number v-model="numero"></generate-number>

          <div>
            <v-btn
              :loading="findBtnLoading"
              color="success"
              :class="
                `${
                  $vuetify.breakpoint.xs ? 'mt-4 ' : 'mt-2'
                } mx-2 font-weight-bold`
              "
              width="200"
              aria-label="Consultar por nombre o razón social"
              @click="
                consultar
              "
            >Consultar</v-btn>

            <v-btn
              :class="
                `${
                  $vuetify.breakpoint.xs ? 'mt-4 ' : ' mt-2'
                } mx-2 font-weight-bold`
              "
              width="200"
              dark
              color="grey"
              @click="clear"
              aria-label="Nueva Consulta nombre o razón social"
            >Nueva Consulta</v-btn>
          </div>
        </v-col>
      </v-col>
      <v-col class="text-center">
        <v-dialog v-model="show" width="500">
          <Notifier
            v-if="show && consulted"
            :message="message"
            :type="alertType"
            @close="show = false"
          />
        </v-dialog>
      </v-col>
    </v-col>
  </v-row>
</template>
<script>
//Components
import GenerateNumber from "@/components/GenerateNumber";
import FormSelect from "@/components/FormSelect";
import FormInput from "@/components/FormInput";
import FormButton from "@/components/FormButton";
import Notifier from "@/components/Notifier";
import moment from "moment";
import { mapGetters } from "vuex";

//Config
// // // import axios from "axios";

export default {
  name: "Home",
  components: {
    GenerateNumber,
    FormSelect,
    FormInput,
    FormButton,
    Notifier,
  },
  data() {
    return {
      soloActivos: true,
      date: moment().format("YYYY-MM-DD"),
      menu: false,
      consulted: false,
      show: false,
      status: {
        loading: false,
        error: false,
        message: "",
      },
      message: "",
      alertType: "info",
      tab: "",
      info: null,
      tipoPersonas: [
        { name: "Natural", cod: "nat" },
        { name: "Jurídica", cod: "jur" },
      ],
      results: "",

      selectTipoPersona: "",
      nombre: "",
      numero: "",
      fecha: null,
      conFecha: false,
      dias: null,
      minFecha: null,
      maxFecha: null,

      //Buttons
      findBtnLoading: false,

      //Error
      errorNombre: false,
      errorTipoPersona: false,
    };
  },
  computed: {
    ...mapGetters("process", [
      "getProcesos",
      "getStatus",
      "getPaginaActualProcesos",
      "getPaginacionProcesos",
    ]),
  },
  watch: {
    getPaginaActualProcesos(pagina) {
      if (this.getProcesos.length) {
        console.log(this.getProcesos);
        this.find();
      }
    },

    dias(dia) {
      if (dia <= 30) {
        let date = this.$moment();
        this.fecha = this.$moment().subtract(dia, "day").format("YYYY-MM-DD");
      } else {
        this.fecha = this.$moment().format("YYYY-MM-DD");
        this.dias = 0;
      }
    },
    fecha(fecha) {
      let before = this.$moment().subtract(30, "day").format("YYYY-MM-DD");
      let now = this.$moment().format("YYYY-MM-DD");
      if (
        this.$moment(before) <= this.$moment(fecha) &&
        this.$moment(now) >= this.$moment(fecha)
      ) {
        this.dias = this.$moment(now).diff(this.$moment(fecha), "days");
      } else {
        this.fecha = this.$moment().format("YYYY-MM-DD");
        this.dias = 0;
      }
    },
  },
  methods: {
    consultar() {
      if (this.validateForm()) {
        this.$emit("clear-process-id");
        this.$store.dispatch("process/setProcesos", []);
        this.$store.dispatch("process/setPaginaProcesos", 1);
        this.$store.commit("process/setPaginacion", {
          name: "paginacionProcesos",
          value: {
            ...this.getPaginacionProcesos,
            pagina: 1,
          },
        });
        this.find();
      }
    },
    async find() {
      try {
        if (this.validateForm()) {
          this.findBtnLoading = true;
          debugger
          await this.$store.dispatch("process/razonSocial", {
            nombre: this.nombre,
            selectTipoPersona: this.selectTipoPersona,
            numero: this.numero,
            soloActivos: this.soloActivos,
          });
          this.findBtnLoading = false;

          if (!this.getProcesos.length) {
            this.consulted = true;

            if (!this.getStatus.error) {
              this.$store.dispatch(
                "process/mostrarNotificacionRespuestaVacia",
                this.soloActivos
              );
            } else {
              this.$store.dispatch("process/mostrarNotificacionError");
            }
          } else {
            if (this.getProcesos.length > 1) {
              this.$store.dispatch(
                "process/mostraNotificacionVariosRegistros",
                "razon-social"
              );
            }
            this.$emit("go-to-list");
          }

          this.duplicated = 0;
        }
      } catch (error) {
        console.log(error);
        this.findBtnLoading = false;
      }
    },
    validateForm() {
      if (this.selectTipoPersona == "") {
        this.errorTipoPersona = true;
        return false;
      } else if (this.nombre == "") {
        this.errorNombre = true;
        return false;
      } else return true;
    },
    clear() {
      this.nombre = "";
      this.selectTipoPersona = "";
      this.soloActivos = true;
      this.$bus.emit("clear-generate-number");
      this.$store.dispatch("process/clearProcesos");
      if (this.$route.meta.active) {
        this.$router.push("/Procesos/NumeroRadicacion");
      }
    },
  },
  created() {
    this.minFecha = this.$moment().subtract(30, "day").format("YYYY-MM-DD");
    this.maxFecha = this.$moment().format("YYYY-MM-DD");
  },
};
</script>
<style scoped>
.processFilterBox {
  border: 0.1rem solid rgba(0, 0, 0, 0.8);
  border-radius: 1rem !important;
}
</style>
